import React from 'react'
import { useTranslation } from 'react-i18next'
import { useLazyQuery, gql } from '@apollo/client'
import moment from 'moment'

import HeaderExportButton from 'components/global/Buttons/HeaderExportButton'
import { useUser} from 'store'
import { downloadBase64 } from 'utils'

import { useYearRange } from '../Traffic/store'

const OPERATION_PURCHASES_EXPORT = gql`
  query purchasesStatsExport($year: Int!, $site_sf_ids: [ID]) {
    base64: purchasesStatsExport(year: $year, site_sf_ids: $site_sf_ids)
  }
`

const OPERATION_COUPONS_AND_PURCASES_EXPORT = gql`
  query purchasesAndCouponsStatsExport($year: Int!, $site_sf_ids: [ID]) {
    base64: purchasesAndCouponsStatsExport(year: $year, site_sf_ids: $site_sf_ids)
  }
`

const Export = ({siteSfIds}) => {
  const { t } = useTranslation()
  const [yearRange] = useYearRange()
  const [user] = useUser()
  const [launchExport, { loading }] = useLazyQuery(
    user?.admin || (user?.roles['statistic_coupons'] && user?.roles['statistic_purchases']) ? OPERATION_COUPONS_AND_PURCASES_EXPORT : OPERATION_PURCHASES_EXPORT
  )

  const handleClick = async () => {
    const { data: { base64 } } = await launchExport({ variables: { year: yearRange, site_sf_ids: siteSfIds } })
    await downloadBase64({ base64, fileName: `achats_${moment().format('DD/MM/YYYY')}.xls`})
  }

  return (
    <HeaderExportButton
      analyticsName="stats_purchases"
      onClick={handleClick}
      loading={loading}
      loadingLabel={t('ui_elements.in_progress')}
      sx={{
        alignSelf: 'flex-start',
        ml: 'auto',
        flexShrink: 0
      }}
    >
      {t('export.button')}
    </HeaderExportButton>
  )
}


export default Export
